var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_930_5055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50027 -0.000732422H4.50016C2.85091 -0.000732422 1.50049 1.35013 1.50049 2.99938V20.9992C1.50049 22.6484 2.85091 23.9993 4.50016 23.9993H7.50027C9.14952 23.9993 10.5004 22.6484 10.5004 20.9992V2.99938C10.5004 1.35013 9.14952 -0.000732422 7.50027 -0.000732422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5002 -0.000732422H16.5001C14.8509 -0.000732422 13.5 1.35013 13.5 2.99938V20.9992C13.5 22.6484 14.8509 23.9993 16.5001 23.9993H19.5002C21.1495 23.9993 22.4999 22.6484 22.4999 20.9992V2.99938C22.4999 1.35013 21.1495 -0.000732422 19.5002 -0.000732422Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_930_5055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 -0.000732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.84311c9aa6fe0a2f6631eec047f34eaf.svg";
export { ForwardRef as ReactComponent };